/* tslint:disable:indent */
// Angular
import {Component, Inject, OnInit} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import {Website} from '../../../../../models/website.model';
import {WccService} from '../../../../../services/wcc-service';
import {Promotion} from '../../../../../models/promotion.model';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {BehaviorSubject} from 'rxjs';
import {PromotionService} from '../../../../../services/promotion-service';
import {DialogErrorComponent} from '../../../../../dialogs/dialog-error/dialog-error.component';

@Component({
	selector: 'app-dialog-new-promotion',
	templateUrl: './dialog-new-promotion.component.html'
})
export class DialogNewPromotionComponent implements OnInit {

	defaultPromoTextMaxLength: number = 2000;
	defaultCouponMaxLength: number = 20;
	result: Promotion;
	promotionForm: FormGroup;
	loadingSmsAccountBalance$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

	constructor(
		public dialogRef: MatDialogRef<DialogNewPromotionComponent>,
		private dialog: MatDialog,
		private formBuilder: FormBuilder,
		public promotionService: PromotionService,
		@Inject(MAT_DIALOG_DATA) public data: {
			promotion: Promotion
		}
	) { }

	ngOnInit() {
		this.result = Object.assign({}, this.data.promotion);
		this.createForm();
	}

	createForm() {
		this.promotionForm = this.formBuilder.group({
			promoName: [this.result.name],
			masterPromoText: [this.result.masterPromoText, [Validators.maxLength(this.defaultPromoTextMaxLength)]],
			hostingCoupon: [this.result.hostingCoupon,  [Validators.pattern('[a-zA-z0-9]*'), Validators.maxLength(this.defaultCouponMaxLength)]],
			hostingPromoText: [this.result.hostingPromoText, [Validators.maxLength(this.defaultPromoTextMaxLength)]],
			streamingCoupon: [this.result.streamingCoupon,  [Validators.pattern('[a-zA-z0-9]*'), Validators.maxLength(this.defaultCouponMaxLength)]],
			streamingPromoText: [this.result.streamingPromoText, [Validators.maxLength(this.defaultPromoTextMaxLength)]],
			applicationsCoupon: [this.result.applicationsCoupon,  [Validators.pattern('[a-zA-z0-9]*'), Validators.maxLength(this.defaultCouponMaxLength)]],
			applicationsPromoText: [this.result.applicationsPromoText, [Validators.maxLength(this.defaultPromoTextMaxLength)]],
			resellerHostingCoupon: [this.result.resellerHostingCoupon,  [Validators.pattern('[a-zA-z0-9]*'), Validators.maxLength(this.defaultCouponMaxLength)]],
			resellerHostingPromoText: [this.result.resellerHostingPromoText, [Validators.maxLength(this.defaultPromoTextMaxLength)]],
			resellerStreamingCoupon: [this.result.resellerStreamingCoupon,  [Validators.pattern('[a-zA-z0-9]*'), Validators.maxLength(this.defaultCouponMaxLength)]],
			resellerStreamingPromoText: [this.result.resellerStreamingPromoText, [Validators.maxLength(this.defaultPromoTextMaxLength)]],
			categoryOverridesMasterPromoText: [this.result.categoryOverridesMasterPromoText]
		});
	}

	get f(){
		return this.promotionForm.controls;
	}

	onNoClick(): void {
		this.dialogRef.close(null);
	}

	onYesClick(): void {
		this.result.name = this.f.promoName.value;
		this.result.masterPromoText = this.f.masterPromoText.value;
		this.result.hostingCoupon = this.f.hostingCoupon.value;
		this.result.hostingPromoText = this.f.hostingPromoText.value;
		this.result.streamingCoupon = this.f.streamingCoupon.value;
		this.result.streamingPromoText = this.f.streamingPromoText.value;
		this.result.applicationsCoupon = this.f.applicationsCoupon.value;
		this.result.applicationsPromoText = this.f.applicationsPromoText.value;
		this.result.resellerHostingCoupon = this.f.resellerHostingCoupon.value;
		this.result.resellerHostingPromoText = this.f.resellerHostingPromoText.value;
		this.result.resellerStreamingCoupon = this.f.resellerStreamingCoupon.value;
		this.result.resellerStreamingPromoText = this.f.resellerStreamingPromoText.value;
		this.result.categoryOverridesMasterPromoText = this.f.categoryOverridesMasterPromoText.value;

		this.promotionService.updatePromotion(this.result)
			.subscribe( (response: any) => {
				if (!response.error) {
					this.dialogRef.close(1);
				} else {
					this.dialogRef.close(0);
				}
			}, (errorResponse: any) => {
				this.handleError(errorResponse.error.message.information);
			});
	}

	handleError(errorInformation: string){
		return this.dialog
			.open(DialogErrorComponent, {
				data: {
					error: errorInformation,
				},
				width: '600px',
				role: 'dialog'
			})
			.afterClosed()
			.subscribe();
	}

}
